module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Light-a066b1d87ae750a41af8f74a66098054.ttf";